module.exports = __webpack_public_path__ + "src/assets/img/logo-desktop.03ffab9a.svg";